import type { ConfirmPayload } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPublicApi } from '../../services/api';

export function useConfirmUser(options?: UseMutationOptions<void, unknown, ConfirmPayload>) {
  return useMutation({
    mutationFn: async ({ token, confirmationCode }) => {
      const api = getPublicApi();

      await api.confirmUser({
        confirmRequest: {
          token,
          confirmationCode,
        },
      });
    },
    ...options,
  });
}